import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Redirect, Link } from "react-router-dom";
import firebase from "../../util/firebaseConfig";
// Style
// TODOs logo visual'dan alınacak.
import {
  Form,
  Grid,
  Header,
  Image,
  Segment,
  List,
  Message,
} from "semantic-ui-react";
import alertify from "alertifyjs";
const MemberSignUp = () => {
  const uid = useSelector((state) => state.firebase.auth.uid);
  const [isAvailable, setIsAvailable] = useState(false);
  const [state, setState] = useState({
    email: "",
    officeNo: "",
    personalNo: "",
    strAdd: "",
    strAdd2: "",
    city: "",
    stateProvince: "",
    postalZip: "",
    country: "",
    sender: "",
    senderId: "",
    authority: "Collaborator",
  });

  const handleChange = (e) => {
    setState({
      ...state,
      [e.target.id]: e.target.value,
    });
  };

  const handleVerify = (e) => {
    const db = firebase.firestore();
    const memberArray = [];
    db.collection("members")
      .get()
      .then((snap) => {
        snap.forEach((doc) => {
          if (doc.data().receiver === state.email) {
            memberArray.push({
              receiver: state.email,
            });
            setState({
              ...state,
              email: state.email,
              sender: doc.data().sender,
              senderId: doc.data().senderId,
              authority: "Collaborator",
            });
            setIsAvailable(true);
            alertify.success("Verification Successfull");
          }
        });

        if (memberArray.length === 0) {
          alertify.error("The e-mail address is not registered in the system.");
        }
      });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const db = firebase.firestore();
    firebase
      .auth()
      .createUserWithEmailAndPassword(state.email, state.password)
      .then((regUser) => {
        db.collection("profile")
          .doc(regUser.user.uid)
          .set({
            ...state,
            disabled: false,
            authorId: regUser.user.uid,
            createdAt: new Date(),
          })
          .then(() => {
            regUser.user
              .updateProfile({
                displayName: `${state.firstName} ${state.middleName} ${state.lastName}`,
              })
              .then(() => {
                alertify.success("Registration Successful!");
              })
              .then(() => {
                window.location.reload();
              })
              .catch((err) => {
                alertify.error(err);
              });
          })
          .catch((err) => {
            alertify.error(err);
          });
      });
  };

  if (uid) return <Redirect to="/" />;

  return (
    <Grid
      textAlign="center"
      style={{ height: "79.5vh" }}
      verticalAlign="middle"
    >
      <Grid.Column
        style={{
          maxWidth: 450,
          boxShadow:
            "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
        }}
      >
        <Header
          as="h2"
          color="blue"
          textAlign="center"
          style={{ paddingTop: "6px" }}
        >
          <Image
            src="https://firebasestorage.googleapis.com/v0/b/omnes-immigration.appspot.com/o/assets%2Fimages%2Ficon-set%2Ficon-america.png?alt=media&token=3a531c4a-5eff-43e5-a019-1d3c519cb18b"
            style={{ marginTop: "-6px", marginRight: "8px" }}
          />{" "}
          <span
            style={{
              color: "royalblue",
            }}
          >
            {isAvailable ? "Create a New Account" : "Verify Your Email"}
          </span>
        </Header>
        {isAvailable ? (
          <Form size="large" onSubmit={handleSubmit}>
            <Segment stacked>
              <Header as="h3">Sender of Invitation: {state.sender}</Header>
              <Form.Group>
                <Form.Input
                  id="firstName"
                  fluid
                  onChange={handleChange}
                  label="First name"
                  width={5}
                />
                <Form.Input
                  id="middleName"
                  fluid
                  onChange={handleChange}
                  label="Middle Name"
                  width={5}
                />
                <Form.Input
                  id="lastName"
                  fluid
                  onChange={handleChange}
                  label="Last Name"
                  width={6}
                />
              </Form.Group>
              <Form.Input
                id="password"
                fluid
                icon="lock"
                iconPosition="left"
                placeholder="Password"
                type="password"
                onChange={handleChange}
              />

              <Form.Button
                disabled={
                  state.password === "" ||
                  state.firstName === "" ||
                  state.lastName === ""
                }
                style={{ backgroundColor: "royalblue", color: "white" }}
                fluid
                type="submit"
                size="large"
              >
                Sign Up
              </Form.Button>
            </Segment>
          </Form>
        ) : (
          <Form size="large" onSubmit={handleVerify}>
            <Segment stacked>
              <Form.Input
                id="email"
                fluid
                icon="user"
                iconPosition="left"
                placeholder="E-mail address"
                onChange={handleChange}
              />

              <Form.Button
                style={{ backgroundColor: "royalblue", color: "white" }}
                fluid
                type="submit"
                size="large"
              >
                Verify your email
              </Form.Button>
            </Segment>
          </Form>
        )}

        {isAvailable ? (
          <Message>
            <List>
              <List.Item>
                By clicking Sign Up, you agree to our{" "}
                <Link to="/signup">Terms</Link>,{" "}
                <Link to="/signup">Data Policy</Link> and{" "}
                <Link to="/signup">Cookie Policy</Link>.
              </List.Item>
            </List>
          </Message>
        ) : null}
      </Grid.Column>
    </Grid>
  );
};

export default MemberSignUp;
